export class HsbServerConfigService {
  serverBaseUrl;
  localserverBaseUrl;
  automationServerBaseUrl;
  constructor() {
    this.serverBaseUrl = "https://hsbservicesbeta.com";
    this.automationServerBaseUrl = "https://automation.hsbservices.com";
    this.localserverBaseUrl = 'http://localhost:3000';
  }
  getServerBaseURL() {
    return this.serverBaseUrl;
  }
  getAutomationServerBaseURL() {
    return this.automationServerBaseUrl;
  }
  getLocalServerBaseURL() {
    console.warn('***running on local server');
    return this.localserverBaseUrl;
  }
  getHostName(serverUrl) {
    let host = serverUrl.split('//')[1];
    return host;
  }
  isAlphaFrontEnd() {
    return (this.serverBaseUrl.indexOf('beta',0) !== -1);
  }  
}
